/*  */
import useWindowDimensions from "../../hooks/WindowSize";
import DelegatorTable from "./DelegatorTable";
import DelegatorTableFlipped from "./DelegatorTableFlipped";

export default function DelegatorView(props) {
  const { height, width } = useWindowDimensions();
  const delegators = props.orchInfo.delegators || [];
  let totalStake = 0;
  let sortedDelegators = [];
  for (const thisDelegator of delegators) {
    totalStake += thisDelegator.bondedAmount;
    let inserted = false;
    // Insert the processed object based on share of stake
    for (var idx = 0; idx < sortedDelegators.length; idx++) {
      if (sortedDelegators[idx].bondedAmount < thisDelegator.bondedAmount) {
        sortedDelegators.splice(idx, 0, thisDelegator);
        inserted = true;
        break;
      }
    }
    // Make sure we push it at the end of the list if this T has the lowest total payout
    if (inserted) {
      continue;
    }
    sortedDelegators.push(thisDelegator);
  }
  if (width > 800) {
    return (
      <DelegatorTable
        sortedDelegators={sortedDelegators}
        cachedENS={props.cachedENS}
        totalStake={totalStake}
      />
    );
  } else {
    return (
      <DelegatorTableFlipped
        sortedDelegators={sortedDelegators}
        cachedENS={props.cachedENS}
        totalStake={totalStake}
      />
    );
  }
}
